/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { SUBMIT_CREDENTIAL_TEMPLATE } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface ISubmitTemplateMethods extends IPluginMethodMap {
  getSubmitTemplate(args: any): Promise<any>;
}

export interface SubmitTemplateProps {
  jsonFormat: JSON;
  jsonldFormat: JSON;
  preview: {
    credentialName: string;
    credentialLogo: string;
    credentialDescription: string;
  };
  isSelfAttested: boolean;
}

export class SubmitTemplateService implements IAgentPlugin {
  readonly methods: ISubmitTemplateMethods;

  constructor() {
    this.methods = {
      getSubmitTemplate: this.getSubmitTemplate.bind(this),
    };
  }

  async getSubmitTemplate(args: SubmitTemplateProps) {
    console.log(`args in issue credential`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.mutate({
          mutation: SUBMIT_CREDENTIAL_TEMPLATE,
          variables: {
            input: {
              jsonFormat: args?.jsonFormat,
              jsonldFormat: args?.jsonldFormat,
              name: args?.preview?.credentialName,
              logo: args?.preview?.credentialLogo,
              description: args?.preview?.credentialDescription,
              selfAttested:args?.isSelfAttested
            },
          },
          fetchPolicy: "no-cache",
        });
        if (res?.data?.createCredentialSchema) {
          console.log(`table data`, res);
          return {
            ...res?.data?.createCredentialSchema,
            notification: notification?.createTemplate,
          };
        }
      }
    } catch (err: any) {
      return err;
    }
  }
}
